import React, { useState, useRef, useEffect } from 'react'
import EmployeDashboardLayout from './EmployeDashboardLayout'
import { useDispatch, useSelector } from 'react-redux'
import { corporateEditEmployeeSchema } from '../../../schemas/corporateEditEmployeSchema'
import { useFormik } from 'formik'
import { StandaloneSearchBox, GoogleMap, useJsApiLoader, } from '@react-google-maps/api'
import { base, errorHandler, services } from '../../../constants/base'
import { corporateUpdateEmployeeAPI } from '../../../redux/slices/CorporateAddEmployee'
import { toast } from 'react-toastify'
import { updateUser } from '../../../redux/slices/authSlice'
import { showEmployeServices } from '../../../redux/slices/employeeServices'
import { professionalDeleteService, ProfessionalServicesAPI, ProfessionalServicesShowAPI } from '../../../redux/slices/ProfessionalServcicesSlice'

const EmployeProfile = () => {

    const dispatch = useDispatch();
    const [deletedId, setDeletedId] = useState("")

    const employee = useSelector(state => state?.AuthSlice?.user)
    const loading = useSelector(state => state.ProfessionalAddServicesSlice.loading)
    const saveBtnloading = useSelector(state => state.coporateAddEmployeSlice.updateEmployeeloading)
    const deleteLoading = useSelector(state => state.ProfessionalAddServicesSlice.deleteLoading)
    const allServices = useSelector(state => state?.ProfessionalAddServicesSlice?.services)

    const corporateId = employee?.parent_id;

    // IMAGE PREVIEW AND OTHER DOCUMENT THAT SHOW
    const imagePreview = employee?.images?.[0]?.path;
    const [employeeImagePreview, setEmployeeImagePreview] = useState(null);

    const otherPreview = employee?.images?.[1]?.path;
    const [showOtherDocument, setShowOtherDocument] = useState("")

    useEffect(() => {
        if (imagePreview) {
            setEmployeeImagePreview(`${base.imageUrl}${imagePreview}`);
        }
        if (otherPreview) {
            setShowOtherDocument(otherPreview)
        }
    }, [imagePreview]);

    const handleImageChange = (e) => {
        const file = e.currentTarget.files[0];
        const reader = new FileReader();
        reader.onloadend = () => {
            setEmployeeImagePreview(reader.result);
        };
        if (file) {
            reader.readAsDataURL(file);
            formik.setFieldValue('profile', file);
        }
    };

    const handleDocumentChange = (e) => {
        const file = e.currentTarget.files[0];
        if (file) {
            formik.setFieldValue('other', file);
            setShowOtherDocument(file.name);
        }
    };
    // IMAGE PREVIEW AND OTHER DOCUMENT THAT SHOW

    // GOOGLE API LOCATION
    const inputRef = useRef(null);
    const [coordinates, setCoordinates] = useState({ lat: null, lng: null });

    const [getLocationAttributes, setGetLocationAttributes] = useState({})

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: process.env.REACT_APP_GOOGLEMAPS_API_KEY,
        libraries: ["places"]
    });

    const handlePlacesChange = () => {
        const places = inputRef.current.getPlaces();
        if (places && places?.length > 0) {
            const place = places[0];
            const lat = place.geometry.location.lat();
            const lng = place.geometry.location.lng();
            setCoordinates({ lat, lng });
            formik.setFieldValue('address', place.formatted_address);
            formik.setFieldValue('latitude', lat);
            formik.setFieldValue('longitude', lng);
            setGetLocationAttributes({
                address: place.formatted_address,
                longitude: lng,
                latitude: lat
            });
        }
    };
    // GOOGLE API LOCATION

    const formik = useFormik({
        initialValues: {
            name: employee?.name || "",
            phone_no: employee?.phone_no || "",
            ss_number: employee?.ss_number || "",
            email: employee?.email || "",
            address: employee?.address?.address || "",
            about: employee?.about || "",
            profile: null,
            other: null,
            latitude: employee?.address?.latitude || "",
            longitude: employee?.address?.longitude || "",
            user_id: corporateId
        },
        validationSchema: corporateEditEmployeeSchema,
        enableReinitialize: true,
        onSubmit: async (values) => {
            const formData = new FormData();
            if (values.profile) {
                formData.append('profile', values.profile);
            }
            if (values.other) {
                formData.append('other', values.other);
            }
            Object.keys(values).forEach((key) => {
                if (key !== 'profile' && key !== 'other') {
                    formData.append(key, values[key]);
                }
            });

            const res = await dispatch(corporateUpdateEmployeeAPI({ data: formData, employee_id: employee.id }));

            if (corporateUpdateEmployeeAPI.fulfilled(res)) {
                if (res.payload.status === 200 || res.payload.data.status) {
                    toast.success('Profile updated successfully!');
                    dispatch(updateUser(res.payload.data.data))
                    localStorage.setItem("user", JSON.stringify(res.payload.data.data))
                } else {
                    errorHandler(res.payload.errors);
                }
            } else if (corporateUpdateEmployeeAPI.rejected(res)) {
                errorHandler(res.payload.errors);
            } else {
                toast.error('Sorry, something went wrong!');
            }
        }
    });

    ////////////////////////////////SERVICES FOR EMPLOYEE//////////////////////////////////////////

    const fetchEmployeeServices = async () => {
        const id = employee?.id;
        if (!id) {
            console.error("Employee ID is undefined");
            return;
        }
        try {
            const res = await dispatch(ProfessionalServicesShowAPI(id));
            if (!res?.data) {
                // console.error("Data is missing in the response");
            }
        } catch (error) {
            // console.error("Error fetching employee services:", error);
        }
    };

    useEffect(() => {
        if (employee) {
            fetchEmployeeServices();
        }
    }, [employee]);

    ///////////////////////////SERVICES ADD AGAINST EMPLOYE/////////////////////////////////
    const [addServicesFormData, setAddServicesFormData] = useState({
        name: '',
        currency: '$',
        price: '',
        user_id: employee?.id,
        corporate_id: employee?.parent_id,
    });

    const addServiceshandleChange = (e) => {
        const { name, value } = e.target;
        setAddServicesFormData({
            ...addServicesFormData,
            [name]: value
        });
    };

    const addServiceshandleSubmit = async (e) => {
        e.preventDefault();
        const res = await dispatch(ProfessionalServicesAPI(addServicesFormData));
        if (res.type === 'ProfessionalServicesAPI/fulfilled') {
            if (res?.payload?.success || res?.payload?.status === 200) {
                const closeButton = document.querySelector("#close-btn-services");
                if (closeButton) {
                    closeButton.click();
                }
                fetchEmployeeServices();
                setAddServicesFormData({
                    name: '',
                    currency: '$',
                    price: '',
                    user_id: employee?.id,
                    corporate_id: employee?.parent_id,
                })
            } else {
                errorHandler(res?.payload?.errors);
            }
        } else if (res.type === 'ProfessionalServicesAPI/rejected') {
            errorHandler(res?.payload?.errors);
        } else {
            toast.error('Sorry, something went wrong!');
        }
    };

    // DELETE SERVICES
    const employeeServicesDelete = async (id) => {
        const res = await dispatch(professionalDeleteService(id))
        if (res?.payload?.data?.status || res?.payload?.status === 200) {
            toast.success("Service Delete Successfully")
            fetchEmployeeServices();
            const closeButton = document.querySelector("#close-btn-update-model-3");
            if (closeButton) {
                closeButton.click();
            }
        } else {
            errorHandler(res?.payload?.errors);
        }
    }
    ///////////////////////////SERVICES ADD AGAINST EMPLOYE/////////////////////////////////
    ////////////////////////////////SERVICES FOR EMPLOYEE//////////////////////////////////////////

    return (
        <>
            <EmployeDashboardLayout>
                <div className="add-employee-box container">
                    <form className='row' onSubmit={formik.handleSubmit}>
                        <div className="mb-3 col-md-6 custom-input-box">
                            <label>Full Name</label>
                            <input
                                type="text"
                                value={formik.values.name}
                                className="form-control"
                                name="name"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                            {formik.errors.name && formik.touched.name && (
                                <div style={{ color: 'red', marginTop: '5px', fontSize: '14px' }}>
                                    {formik.errors.name}
                                </div>
                            )}
                        </div>

                        <div className="mb-3 col-md-6 custom-input-box">
                            <label>Email Address</label>
                            <input
                                type="email"
                                value={formik.values.email}
                                className="form-control"
                                name="email"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                            {formik.errors.email && formik.touched.email && (
                                <div style={{ color: 'red', marginTop: '5px', fontSize: '14px' }}>
                                    {formik.errors.email}
                                </div>
                            )}
                        </div>

                        <div className="mb-3 col-md-6 custom-input-box">
                            <label>Phone Number</label>
                            <input
                                type="text"
                                value={formik.values.phone_no}
                                className="form-control"
                                name="phone_no"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                            {formik.errors.phone_no && formik.touched.phone_no && (
                                <div style={{ color: 'red', marginTop: '5px', fontSize: '14px' }}>
                                    {formik.errors.phone_no}
                                </div>
                            )}
                        </div>

                        <div className="mb-3 col-md-6 custom-input-box">
                            <label>Social Security Number</label>
                            <input
                                type="text"
                                value={formik.values.ss_number}
                                className="form-control"
                                name="ss_number"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                            {formik.errors.ss_number && formik.touched.ss_number && (
                                <div style={{ color: 'red', marginTop: '5px', fontSize: '14px' }}>
                                    {formik.errors.ss_number}
                                </div>
                            )}
                        </div>

                        <div className="mb-3 col-md-12 custom-input-box">
                            <label>Address</label>
                            {isLoaded && (
                                <StandaloneSearchBox
                                    onLoad={(ref) => (inputRef.current = ref)}
                                    onPlacesChanged={handlePlacesChange}
                                >
                                    <input
                                        type="text"
                                        value={formik.values.address}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        className={'form-control'}
                                        name="address"
                                        placeholder="Enter your address"
                                    />
                                </StandaloneSearchBox>
                            )}
                            {formik.errors.address && formik.touched.address && (
                                <div style={{ color: 'red', marginTop: '5px', fontSize: '14px' }}>
                                    {formik.errors.address}
                                </div>
                            )}
                        </div>

                        <div className="mb-3 col-md-12 custom-input-box">
                            <label>About Yourself</label>
                            <textarea
                                className="form-control"
                                value={formik.values.about}
                                name="about"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                            {formik.errors.about && formik.touched.about && (
                                <div style={{ color: 'red', marginTop: '5px', fontSize: '14px' }}>
                                    {formik.errors.about}
                                </div>
                            )}
                        </div>

                        {/* <div className="logo-box">
                            <h3 className="second-text-heading mb-3">Add Services</h3>

                            <span
                                className="add-services-button w-25"
                                data-bs-toggle="modal"
                                href="#exampleModalToggle"
                                role="button"
                            >
                                Add Services <i className="fa-solid fa-plus"></i>
                            </span>

                            <div className="services-array-box">
                                {allServices?.map((item, index) => {
                                    return (
                                        <span key={index}>
                                            {item?.name}
                                            <i data-bs-toggle="modal" onClick={() => setDeletedId(item?.id)} href="#exampleModalToggle3" role="button" className="fas fa-trash delete-icon"></i>
                                        </span>
                                    );
                                })}
                            </div>
                        </div> */}

                        <div className="logo-box col-md-6">
                            <h3 className="second-text-heading">Profile Picture</h3>
                            <img src={employeeImagePreview} alt="Profile" style={{ width: 100, height: 100, borderRadius: '50%', objectFit: 'cover', marginBottom: 10 }} />
                            <div>
                                <label htmlFor="upload-image" className="upload-image">
                                    <span>Upload Image</span>
                                </label>
                                <input
                                    type="file"
                                    className="d-none"
                                    id="upload-image"
                                    name="profile"
                                    onChange={handleImageChange}
                                />
                            </div>
                            {formik.errors.profile && formik.touched.profile && (
                                <div style={{ color: 'red', marginTop: '5px', fontSize: '14px' }}>
                                    {formik.errors.profile}
                                </div>
                            )}
                        </div>

                        <div className="logo-box col-md-6">
                            <h3 className="second-text-heading mb-0">Attached Document</h3>
                            <p className='mt-2 mb-2' style={{ wordBreak: 'break-all' }}>
                                <strong>Document Name:</strong> {showOtherDocument}
                            </p>
                            <label htmlFor="upload-image-2" className="upload-image">
                                <span>Upload Document</span>
                            </label>
                            <input
                                type="file"
                                className="d-none"
                                id="upload-image-2"
                                accept=".pdf,.doc,.docx"
                                name="document"
                                onChange={handleDocumentChange}
                            />
                            {formik.errors.document && formik.touched.document && (
                                <div style={{ color: 'red', marginTop: '5px', fontSize: '14px' }}>
                                    {formik.errors.document}
                                </div>
                            )}
                        </div>

                        <div className="submit-btn-form mb-3">
                            <button type="submit" disabled={saveBtnloading} className="btn btn-primary">
                                {!saveBtnloading ? "Save" : (
                                    <i
                                        style={{ fontSize: "22px" }}
                                        className="fa-solid fa-spinner fa-spin"
                                    ></i>
                                )}
                            </button>
                        </div>
                    </form>
                </div>

                {/* MODEL HERE */}
                <div
                    className="modal fade"
                    data-bs-backdrop="static"
                    id="exampleModalToggle"
                    aria-hidden="true"
                    aria-labelledby="exampleModalToggleLabel"
                    tabIndex={-1}
                >
                    <div className="modal-dialog modal-dialog-centered service-add-model">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button
                                    type="button"
                                    className="btn-close"
                                    id="close-btn-services"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <i className="fa-solid fa-xmark"></i>
                                </button>
                            </div>

                            <div className="modal-body">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <form onSubmit={addServiceshandleSubmit}>
                                                <div className="employee-form-box">
                                                    <h2>Add Service:</h2>
                                                </div>

                                                <div className="add-service-box">
                                                    <div className="add-service-input custom-input-box">
                                                        <select
                                                            name="name"
                                                            className="add-service-control"
                                                            value={addServicesFormData.name}
                                                            onChange={addServiceshandleChange}
                                                        >
                                                            <option value="" disabled>
                                                                Select Service
                                                            </option>
                                                            {services?.map((item, index) => {
                                                                return <option value={item?.label} key={index}>{item?.label}</option>
                                                            })}
                                                        </select>
                                                    </div>
                                                </div>

                                                <div className="add-service-box custom-input-box">
                                                    <label htmlFor="currency-select">Select Currency:</label>
                                                    <select
                                                        name="currency"
                                                        id="currency-select"
                                                        className="form-control add-service-control"
                                                        value={addServicesFormData.currency}
                                                        onChange={addServiceshandleChange}
                                                    >
                                                        {/* <option value="" disabled>
                                                            Select Currency
                                                        </option> */}
                                                        <option value="USD" selected>USD</option>
                                                        <option value="POUND">POUND</option>
                                                        <option value="PKR">PKR</option>
                                                    </select>
                                                </div>

                                                <div>
                                                    <h3 className="form-sub-heading">Price per hour:</h3>
                                                    <div className="price-service-box">
                                                        <div className="add-service-input custom-input-box">
                                                            <span className="currency-symbol">
                                                                {addServicesFormData.currency === "USD"
                                                                    ? "$"
                                                                    : addServicesFormData.currency === "POUND"
                                                                        ? "£"
                                                                        : addServicesFormData.currency === "PKR"
                                                                            ? "₨"
                                                                            : "$"}
                                                            </span>
                                                            <input
                                                                type="number"
                                                                className="price-input"
                                                                name="price"
                                                                value={addServicesFormData.price}
                                                                onChange={addServiceshandleChange}
                                                                placeholder="Enter custom price"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="submit-btn-form justify-content-end mb-4 mt-4">
                                                    <button type="submit" disabled={loading} className="btn btn-primary">
                                                        {!loading ? (
                                                            "Save"
                                                        ) : (
                                                            <i
                                                                style={{ fontSize: "22px" }}
                                                                className="fa-solid fa-spinner fa-spin"
                                                            ></i>
                                                        )}
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="modal fade" data-bs-backdrop="static" id="exampleModalToggle3" aria-hidden="true" aria-labelledby="exampleModalToggleLabel2" tabindex="-1">
                    <div className="modal-dialog modal-dialog-centered service-add-model">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="btn-close" id='close-btn-update-model-3' data-bs-dismiss="modal" aria-label="Close">
                                    <i className="fa-solid fa-xmark"></i>
                                </button>
                            </div>

                            <div className="modal-body">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-md-12 mt-4">
                                            <div className="full-name-box justify-content-center">
                                                <h1>Are your sure you want to delete service?</h1>
                                            </div>
                                            <div className="justify-content-center d-flex mb-4 mt-4">
                                                <button type="button" className="btn btn-danger me-2" onClick={() => employeeServicesDelete(deletedId)}>
                                                    {deleteLoading ? (
                                                        <i style={{ fontSize: "22px" }} className="fa-solid fa-spinner fa-spin"></i>
                                                    ) : "Delete"}
                                                </button>

                                                <button type="button" id='close-btn-update-model-3' data-bs-dismiss="modal" aria-label="Close" className="btn btn-secondary">
                                                    Cancel
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </EmployeDashboardLayout>
        </>
    )
}

export default EmployeProfile